import { EventController } from './EventController';

/**
 * Pure Controller are those that have no dependency on any other business logic.
 * And therefore can be initialised whenever
 */
export class PureController<T extends string> extends EventController<T> {}
